import { atom } from 'jotai';

type merchantInformation = {
  merchantId?: string;
  locationId?: string;
  type?: 'instore' | 'dining';
};

const storeMarkerModalAtom = atom<merchantInformation | undefined>(undefined);
const openDetailModalAtom = atom<undefined | (() => void)>(undefined);

export { openDetailModalAtom, storeMarkerModalAtom };
